/* eslint-disable react/no-danger */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from '../EcsPortal.module.scss';
import styles2 from '../../../styles/Accordion.module.scss';
import styles3 from './Faq.module.scss';
import BannerCategory from '../BannerCategory';
import BannerFrameDeliveryStatus from '../BannerFrameDeliveryStatus';
import BannerRedirection from '../BannerRedirection';
import LinkWebsiteInput from '../LinkWebsiteInput';
import useAlert from '../../../hooks/useAlert';
import { useSessionStorage } from '../../../hooks';
import {
  bannerNotSignedListObj,
  CheckingValidSearch,
  defaultEnableBtnStyles,
  getContractTypeVal,
  getSourceValue,
  handleRedirection,
} from '../../../lib/common';
import { handleLoginPopup, handleSetFaqData } from '../../../reducersAndActions/actions/appStateActions';
import FaqTicketCreate from '../../common/FaqTicketCreate';
import { useAuth } from '../../../contexts/auth';
import { useAppState } from '../../../contexts/appState';
import Certificate from '../JDRRCertificate/Certificate';
import { handleImpressionsTrack, CreateTicket, uploadFiles } from '../../../api';

export default function BannerFaqs({
  faqdetails,
  bannerData,
  setBannerData,
  searchQuestion,
  handleSearchFaq,
  hLinkResp,
  setHLinkResp,
  activeIndex,
  setActiveIndex,
  projectId,
  handleBannerRedirection,
}) {
  const [authState] = useAuth();
  const { selectedBusiness, type } = authState;
  const [appState, appDispatch] = useAppState();
  const [setAlert] = useAlert();
  const content = useRef(null);
  const source = getSourceValue();
  const getBannerType = sessionStorage.getItem('bannerType');
  const navigate = useNavigate();
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio')) || {};
  const contractVal = getContractTypeVal(projectId);
  const fileRef = useRef(null);
  const [images, setImages] = useState([]);
  const queryParams = new URLSearchParams(window.location.search);
  const [userDetails] = useSessionStorage('userDetails', '');
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const [disable, setDisable] = useState(false);
  const [uploadError, setUploadError] = useState('');

  useEffect(() => {
    document.body.style.overflow = 'unset';
  }, []);

  const validSearchValue = CheckingValidSearch(searchQuestion);

  const handleFaqChange = async (faqObj, index) => {
    const isClosing = activeIndex === index;
    setActiveIndex(isClosing ? -1 : index);
    if (isClosing) {
      setImages([]);
    }

    if (!isClosing) {
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = `faq_${faqObj?.faqKey}`;
        const faqTypeVal = '';
        const othersData = [];
        const bannerTrackType =
          getBannerType === 'Mobile Banner' ? 'mobile' : getBannerType === 'JDRR Certificate' ? 'jdrr' : 'web';
        const llTrd = `issue_${bannerTrackType}banner`;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
    }
    if (hLinkResp) {
      handleSetFaqData(appDispatch, {
        faqData: [],
      });
    }
    setHLinkResp('');
  };

  const handleBannerRedirect = async () => {
    if (projectId === 'csportal') {
      const bannerTrackType =
        getBannerType === 'Mobile Banner'
          ? 'mobilebanner'
          : getBannerType === 'JDRR Certificate'
            ? 'jdrrCertificate'
            : 'webbanner';
      const liVal = 'click';
      const liTrd = `cta_clickhere`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_${bannerTrackType}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);

      if (getBannerType === 'JDRR Certificate') {
        const redirectionUrl = `https://www.justdial.com/BNR-${
          selectedBusiness?.shorturl || ''
        }?hide_header=1&support=1&source=${source}`;
        handleRedirection(source, redirectionUrl);
      } else {
        handleBannerRedirection();
      }
    }
  };

  const bannerNotSignedList =
    getBannerType === 'Mobile Banner'
      ? bannerNotSignedListObj[projectId].mobileBannerNotSignedList
      : getBannerType === 'JDRR Certificate'
        ? bannerNotSignedListObj[projectId].jdrrBannerNotSignedList
        : bannerNotSignedListObj[projectId].webBannerNotSignedList;

  const handleTicketCreate = () => {
    sessionStorage.removeItem('faq');
    if (projectId === 'csportal') {
      if (appState?.loginPopup?.nonlogin && !type) {
        handleLoginPopup(appDispatch, { ...appState.loginPopup, open: true, click: true });
        return '';
      }
    }
    const parentid = projectId === 'csportal' ? selectedBusiness?.parentid : selectedBusinessGenio?.parentId;
    const city = projectId === 'csportal' ? selectedBusiness?.data_city : selectedBusinessGenio?.city;

    if (parentid && city) {
      if (projectId === 'csportal' && ['paid', 'expiredShort'].includes(contractVal)) {
        navigate(`/csportal/create_ticket?parentId=${parentid}&city=${city}
        &key=${getBannerType}&vertical=''`);
      } else {
        navigate(
          `/${projectId}/create_ticket?parentId=${parentid}&city=${city}
        &key=${getBannerType}&vertical=''`,
        );
      }
    } else if (appState?.loginPopup?.nonlogin && projectId === 'csportal') {
      handleLoginPopup(appDispatch, { ...appState.loginPopup, open: true, click: true });
    }
    return '';
  };

  const handleSubmit = async () => {
    setDisable(true);
    const document = [];

    images.forEach((item) => {
      document.push({
        nm: item.name,
        url: item.url,
      });
    });

    const params = {
      vertical: 'LISTING',
      category: 'CS',
      ticket_creator: 'BUSINESS',
      nm:
        projectId === 'csportal'
          ? selectedBusiness?.compname || ''
          : selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || '',
      created_by: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
      mob: projectId === 'csportal' ? userDetails?.mobile || '' : selectedBusinessGenio?.mobile || '',
      issue_type: 'JDRR Related',
      issue_sub_type: 'Broken JDRR delivered',
      issue_comment: '',
      document,
      city:
        projectId === 'genio'
          ? selectedBusinessGenio?.city || ''
          : queryParams.get('city') || selectedBusiness?.data_city,
      oid: '',
      orderid: '',
      docid:
        projectId === 'genio'
          ? selectedBusinessGenio?.docId || ''
          : queryParams.get('pid') || selectedBusiness?.docid || '',
      src: projectId === 'genio' ? 'sales-genio' : 'business',
      src_typ:
        projectId === 'genio' ? (selectedBusinessGenio?.concern === 'client' ? 'client' : 'internal') : 'csportal',
      src_nm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
      src_mob: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
      projectId: projectId === 'csportal' ? 1 : '',
      parentId: projectId === 'genio' ? selectedBusinessGenio?.parentId || '' : selectedBusiness?.parentid || '',
      compnm: projectId === 'genio' ? selectedBusinessGenio?.companyName || '' : selectedBusiness?.compname || '',
      source: '',
      classify: 1,
      bypass_autoclassify: 1,
      ...(projectId === 'genio' && {
        agent_mngr_id: profile?.reporteeCode,
        agent_id: profile?.empCode,
      }),
    };
    const res = await CreateTicket(params);
    if (res?.errorCode === 0) {
      setAlert({
        message: res?.result.msg || '',
        status: true,
      });
    } else {
      setAlert({
        message: res?.message || '',
        status: false,
      });
    }
    setTimeout(() => {
      if (projectId === 'genio') {
        navigate('/genio/features');
      } else {
        navigate(-1);
      }
    }, 1500);
  };

  const raiseTicketBtnView = () => (
    <section className="csraiseticket">
      <div
        className={`raiseticketwrp text_center ${
          projectId === 'genio' && bannerData && bannerData?.bannerNotSigned ? 'pt-10' : 'pt-40'
        } pl-20 pr-20`}
      >
        <div className="font12 fw600 color777 pb-10">Didn&apos;t get a solution to your concern?</div>
        <button
          type="button"
          className={`${styles2.Accordion__Contant__Button} bluefill_animate font12 fw600 colorFFF mt-10`}
          style={defaultEnableBtnStyles}
          onClick={() => {
            handleTicketCreate();
          }}
        >
          Raise a Ticket
        </button>
      </div>
    </section>
  );

  const handleRemoveImage = (e, indexToRemove) => {
    e.stopPropagation();

    const updatedImages = images.filter((_, index) => index !== indexToRemove);

    setImages(updatedImages);

    if (updatedImages.length < 5) {
      setUploadError('');
    }
  };

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files);

    // Show error if user selects more than allowed
    if (files.length + images.length > 5) {
      setUploadError('Only 5 images allowed');
    } else {
      setUploadError('');
    }

    const remaining = 5 - images.length;
    const selectedFiles = files.slice(0, remaining);
    const tempImages = [...images];

    try {
      for (const file of selectedFiles) {
        if (file && file.type.startsWith('image/')) {
          const response = await uploadFiles([file], true);

          if (response?.error_code === 0) {
            if (response?.image_urls?.length > 0) {
              tempImages.push({
                name: file.name,
                url: response.image_urls[0],
                preview: URL.createObjectURL(file),
              });
            }
          }
        }
      }

      setImages(tempImages);
    } catch (err) {
      console.log('Error: ', err);
    }
  };

  return (
    <div>
      {bannerData && bannerData?.bannerNotSigned ? (
        <>
          {projectId === 'csportal' && getBannerType === 'JDRR Certificate' ? (
            <Certificate />
          ) : (
            <div className="p-20">
              <div className="font12 fw600 color111">
                {projectId === 'csportal'
                  ? getBannerType === 'JDRR Certificate'
                    ? `This campaign is not signed by you.Make a strong impression on walk in customers by placing JD's review & ratings certificate at your premises!`
                    : `This campaign is not signed by you.Unleash Your Brand's Potential - Stand Out, Shine Bright!`
                  : 'This campaign is not signed up the vendor.'}
              </div>
              <div className="font12 fw600 color111 mt-5">
                {projectId === 'csportal' ? 'Benefits :' : 'Vendor gets :'}
              </div>
              <ul id="bannerList" className="p-20">
                {bannerNotSignedList.map((each, idx) => (
                  <li style={{ listStyleType: 'disc' }} className="font12 fw500 color111" id="bannerListItem" key={idx}>
                    <div
                      aria-label="banner_faq_click"
                      tabIndex={0}
                      role="button"
                      onKeyDown={() => {}}
                      onClick={() => handleBannerRedirect()}
                      dangerouslySetInnerHTML={{
                        __html:
                          idx === 2 && projectId === 'csportal'
                            ? each.replace(
                                'CLICK HERE',
                                '<span style="color:blue" class="highlightClickable font12 fw500 color111">CLICK HERE</span>',
                              )
                            : each,
                      }}
                    />
                  </li>
                ))}
              </ul>
            </div>
          )}
          {projectId === 'genio' && raiseTicketBtnView()}
        </>
      ) : (
        <div className="p-20">
          <div className={`${styles3.Faq_Heading} font16 fw600 color111 text_center mt-5`}>
            Questions? We&apos;ve got instant answers
          </div>

          <div className={`${styles3.Faq__Search} mt-25`}>
            <input
              className={`${styles3.Faq__Input} font13 fw500 color111`}
              type="text"
              placeholder="Search for keywords..."
              onChange={handleSearchFaq}
              value={searchQuestion}
            />
          </div>
          {!validSearchValue && searchQuestion && (
            <span className="colorEC4 font12">Please avoid special characters.</span>
          )}
          <div className={`${styles2.Accordion__Box}`}>
            <div className={`${styles2.Accordion__Pannel} `}>
              <>
                {faqdetails &&
                  faqdetails.map((item, index) => {
                    return (
                      <div key={index}>
                        <div
                          aria-label="bannerFaq_change"
                          tabIndex={0}
                          role="button"
                          onKeyDown={() => {}}
                          className={`${styles2.Accordion__Pannel__Heading} ${
                            activeIndex === index ? styles.Active : ''
                          }`}
                          onClick={() => handleFaqChange(item, index)}
                        >
                          <div className={`${styles2.Accordion__Pannel__Title} font13 fw500 color111`}>
                            {item?.question || ''}
                          </div>
                          <div className={`${styles.Accordion__Pannel__Icon} csicon`} />
                        </div>
                        {index === activeIndex && (
                          <div className={`${styles.Accordion__Contant}`} ref={content} style={{ maxHeight: `0px` }}>
                            <div className={`${styles.Accordion__TextContant}`}>
                              <>
                                {[1, 2, 4, 8, 14, 15, 16].includes(item?.pop) &&
                                item?.data &&
                                Object.keys(item?.data).length > 0 ? (
                                  <>
                                    {item?.pop !== 8 && (
                                      <BannerCategory
                                        data={item?.data}
                                        searchQuestion={searchQuestion}
                                        setAlert={setAlert}
                                        showTicketCreation={[1, 14].includes(item?.pop)}
                                        bannerData={bannerData}
                                        faqId={item?.pop}
                                        projectId={projectId}
                                      />
                                    )}
                                    {item?.pop === 8 && <BannerFrameDeliveryStatus data={item?.data} />}
                                  </>
                                ) : (
                                  <>
                                    {item.pop === 17 ? (
                                      <FaqTicketCreate
                                        ticketCreator="BUSINESS"
                                        issue="Banner related"
                                        subIssue="Categories update"
                                        vertical="LISTING"
                                        category="CS"
                                        hideAlert
                                        hideCrossIcon
                                        faqObj={item}
                                      />
                                    ) : (
                                      ![3, 9, 10, 11, 13, 18, 19, 20, 23].includes(item?.pop) && (
                                        <BannerRedirection projectId={projectId} faqId={item?.pop} faqObj={item} />
                                      )
                                    )}
                                  </>
                                )}

                                {[3, 18].includes(item?.pop) ? (
                                  <>
                                    {hLinkResp ? (
                                      <div className="color777 font14">{hLinkResp || ''}</div>
                                    ) : (
                                      <LinkWebsiteInput
                                        hLink={item?.hLink || ''}
                                        bannerData={bannerData}
                                        setBannerData={setBannerData}
                                        setHLinkResp={setHLinkResp}
                                        projectId={projectId}
                                      />
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <div id="banner-faq-list" dangerouslySetInnerHTML={{ __html: item.ans }} />
                                    {item?.pop === 23 && (
                                      <div className={`${styles3.uploadContainer}`}>
                                        <div className={`${styles3.uploadBox}`}>
                                          <input
                                            type="file"
                                            hidden
                                            multiple
                                            accept="image/*"
                                            ref={fileRef}
                                            onChange={handleUpload}
                                          />
                                          <div className={styles3.previewWrapper}>
                                            {images.length ? (
                                              <>
                                                {images.map((img, index) => (
                                                  <div key={index} className={styles3.previewContainer}>
                                                    <div
                                                      className={styles3.removeIcon}
                                                      role="button"
                                                      tabIndex={0}
                                                      onKeyDown={() => {}}
                                                      onClick={(e) => handleRemoveImage(e, index)}
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="14"
                                                        height="14"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="black"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                      >
                                                        <line x1="18" y1="6" x2="6" y2="18" />
                                                        <line x1="6" y1="6" x2="18" y2="18" />
                                                      </svg>
                                                    </div>
                                                    <img src={img.preview} alt="preview" className={styles3.preview} />
                                                  </div>
                                                ))}
                                                {images.length < 5 && (
                                                  <div
                                                    className={styles3.addMoreBtn}
                                                    onClick={() => fileRef.current.click()}
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyDown={() => {}}
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="28"
                                                      height="28"
                                                      viewBox="0 0 24 24"
                                                      fill="none"
                                                      stroke="#667085"
                                                      strokeWidth="2"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    >
                                                      <line x1="12" y1="5" x2="12" y2="19" />
                                                      <line x1="5" y1="12" x2="19" y2="12" />
                                                    </svg>
                                                  </div>
                                                )}
                                              </>
                                            ) : (
                                              <div
                                                className={styles3.initialUpload}
                                                onClick={() => fileRef.current.click()}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={() => {}}
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="28"
                                                  height="28"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  stroke="#667085"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                >
                                                  <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                                                  <circle cx="12" cy="13" r="4" />
                                                </svg>
                                                <div>UPLOAD PHOTO</div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                        {uploadError && (
                                          <div className="font12 mt-5" style={{ color: 'red' }}>
                                            {uploadError}
                                          </div>
                                        )}
                                        <button
                                          disabled={!images.length || disable}
                                          onClick={() => {
                                            handleSubmit();
                                          }}
                                          className={`${styles3.submitBtn} ${
                                            images.length && !disable ? styles3.activeBtn : ''
                                          }`}
                                        >
                                          SUBMIT
                                        </button>
                                      </div>
                                    )}
                                  </>
                                )}
                              </>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </>
            </div>
          </div>
          {((getBannerType === 'Web Banner' && bannerData?.showWebBannerInProgressImage) ||
            (getBannerType === 'Mobile Banner' && bannerData?.mobileBannerStatus === 'Pending')) &&
            raiseTicketBtnView()}
        </div>
      )}
    </div>
  );
}
BannerFaqs.propTypes = {
  faqdetails: PropTypes.array,
  bannerData: PropTypes.object,
  setBannerData: PropTypes.func,
  searchQuestion: PropTypes.string,
  handleSearchFaq: PropTypes.func,
  hLinkResp: PropTypes.string,
  setHLinkResp: PropTypes.func,
  activeIndex: PropTypes.number,
  setActiveIndex: PropTypes.func,
  projectId: PropTypes.string,
  handleBannerRedirection: PropTypes.func,
};
